import styled from 'styled-components';

export const InfoContainer = styled.div`
    color: #fff;
    background: ${({lightBg}) => (lightBg ? '#f9f9f9' : '#010606' )};

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }
`;

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    min-height: 100vh;
    width: 100%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    padding: 60px 24px 80px;
    justify-content: center;
    align-items: center;
`;

export const InfoRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 48px;
    align-items: center;
    grid-template-areas: ${({ imgStart }) =>
         imgStart ? `'col2 col1'` : `'col1 col2'` };

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        grid-gap: 32px;
        grid-template-areas: ${({ imgStart }) =>
         imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
    }
`;

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`;

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`;

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 0;
`;

export const TopLine = styled.p`
    color: #01bf71;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
    margin-top: 0;
`;

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: ${({lightText}) => (lightText ? '#f7f8fa' : '#010606')};

    @media screen and (max-width :480px) {
        font-size: 32px;
    }
`;

export const Subtitle = styled.p`
    max-width: 540px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 1.6;
    color: ${({darkText}) => (darkText ? '#010606' : '#fff')};
    white-space: pre-line;
`;

export const ListWrapper = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 32px 0;
    max-width: 540px;
`;

export const ListItem = styled.li`
    position: relative;
    padding-left: 28px;
    margin-bottom: 14px;
    font-size: 18px;
    line-height: 1.5;
    color: ${({darkText}) => (darkText ? '#1a1a1a' : '#f0f0f0')};

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 10px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #01bf71;
    }
`;

export const NumberedListWrapper = styled.ol`
    list-style: none;
    counter-reset: item;
    padding: 0;
    margin: 0 0 32px 0;
    max-width: 540px;
`;

export const NumberedListItem = styled.li`
    position: relative;
    padding-left: 44px;
    margin-bottom: 18px;
    font-size: 18px;
    line-height: 1.5;
    color: ${({darkText}) => (darkText ? '#1a1a1a' : '#f0f0f0')};
    counter-increment: item;

    &::before {
        content: counter(item);
        position: absolute;
        left: 0;
        top: 0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #01bf71;
        color: #010606;
        font-size: 14px;
        font-weight: 700;
        line-height: 30px;
        text-align: center;
    }
`;

export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const ImgWrap = styled.div`
    width: 100%;
    max-width: 640px;
    min-height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 768px) {
        min-height: 280px;
    }
`;

export const MediaBox = styled.div`
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    background: rgba(0, 0, 0, 0.08);
`;

export const Img = styled.img`
    width: 100%;
    height: auto;
    display: block;
    vertical-align: middle;
`;

export const MediaVideo = styled.video`
    width: 100%;
    height: auto;
    min-height: 340px;
    object-fit: cover;
    display: block;

    @media screen and (max-width: 768px) {
        min-height: 260px;
    }
`;

